import { useState } from "react";
import { putUsersURL } from "../../utils/ConstantsURL";

export const usePutUsers = ({ token, id }) => {

  const [loading, setLoading] = useState(false);
  
  const putUsers = async (dataForm) => {
    setLoading(true);
    try {
      let response = await fetch(putUsersURL(id), {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(dataForm),
      });

      let data = await response.json();
      if (!response.ok) {
        throw new Error(data.message);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error al editar el usuario:", error);
    } finally {
      setLoading(false);
    }
  };

  return { putUsers, loading };
};
